import { Addresses, ContractName } from "@src/models";

export const ADDRESSES: Addresses = {
  // arbitrum
  "42161": {
    [ContractName.USDC]: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // avalanche
  "43114": {
    [ContractName.USDC]: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // base
  "8453": {
    [ContractName.USDC]: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.CustomXSwapRouter]:
      "0x9B64aC0aD647768838a3957Bc12c40E1C539cb93",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.StakingCosmicCadets]:
      "0x67798736bFb7d9A1F143215E258fe15Da68c85F0",
    [ContractName.StakingSolarDivision]:
      "0xF86e9f328e840658bAc6C5726a76ba4db1eFe923",
    [ContractName.StakingIntergalacticCommand]:
      "0x29A09C1642222eE5ae14EF19445f1326BCFCAC01",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapToken]: "0x8fe815417913a93ea99049fc0718ee1647a2a07c",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // ethereum
  "1": {
    [ContractName.USDC]: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.CustomXSwapRouter]:
      "0x9B64aC0aD647768838a3957Bc12c40E1C539cb93",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapToken]: "0x8fe815417913a93ea99049fc0718ee1647a2a07c",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // optimism
  "10": {
    [ContractName.USDC]: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // polygon
  "137": {
    [ContractName.USDC]: "0xf1e3a5842eeef51f2967b3f05d45dd4f4205ff40",
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // mode
  "34443": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // astar
  "592": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // blast
  "81457": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // celo
  "42220": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // gnosis
  "100": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // kroma
  "255": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // mantle
  "5000": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // shibarium
  "109": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // wemix
  "1111": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // zircuit
  "48900": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // bsc
  "56": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // metis
  "1088": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // linea
  "59144": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // scroll
  "534352": {
    [ContractName.BatchQuery]: "0xb5f9934ea0810ef5faa677e8c68c6983b88664b1",
    [ContractName.FeeCollector]: "0xb37275558f02f05104c2ba35199d16adeb43432f",
    [ContractName.XSwapRouter]: "0xe1c14b9f065dead2e89ee35382f8bd42bdb87a04",
    [ContractName.XSwapRouterSingleChain]:
      "0x0bb24c4302889ea0fb22dfacbb845e5602f35972",
  },
  // 0G
  "16661": {
    [ContractName.BatchQuery]: "0x73d73d323452505518a898066529c01D4c3eF15b",
    [ContractName.FeeCollector]: "0x01CF9356668e94B4efd16842851a7c805199b3F5",
    [ContractName.XSwapRouter]: "0x543F4Ae34DB4d5d11B564b578a2E79221a48CcC2",
    [ContractName.XSwapRouterSingleChain]:
      "0xf6ce7dbdd78A4589A4526278d3f88bd66E040d0d",
  },
  // plasma
  "9745": {
    [ContractName.BatchQuery]: "0x73d73d323452505518a898066529c01D4c3eF15b",
    [ContractName.FeeCollector]: "0x01CF9356668e94B4efd16842851a7c805199b3F5",
    [ContractName.XSwapRouter]: "0x543F4Ae34DB4d5d11B564b578a2E79221a48CcC2",
    [ContractName.XSwapRouterSingleChain]:
      "0xf6ce7dbdd78A4589A4526278d3f88bd66E040d0d",
  },
  // solana
  "mainnet-beta": {
    [ContractName.FeeCollector]: "XSwapfFzSz84kkGk5PCYzLrntPfLubFRJGbJRQjC7th",
  },
};
